const Input = ({ decimalPlaces=2, onChange, max=650, ...rest }) => {
  const changeHandler = (e) => {
    let regex = /^([0-9]*|[0-9]*\.[0-9]{0,2})$/;
    if(regex.test(e.target.value)){
      onChange(e);
    }
  }

  const keydownHandler = (e) => {
    if(e.keyCode === 69){
      e.preventDefault();
    }
  }

  return(
    <input {...rest} type="number" max={max} onChange={changeHandler} onKeyDown={keydownHandler}/>
  )
}

export default Input;
